import actionsTypes from './cta.types';
import axios from 'axios';
import io from 'socket.io-client';
import storage from '../../helpers/storage';

let url;
if (process.env.VUE_APP_NODE_ENV == 'production') {
  url = `${process.env.VUE_APP_API_LIVE_URI}/ctas`;
} else {
  url = `${process.env.VUE_APP_API_TEST_URI}/ctas`;
}

const socket = io(url);
export default {
  addCtaAction({ commit }, data) {
    const ls = storage.get('manager');
    commit(actionsTypes.ADD_CTA_REQUEST);
    const options = {
      url: `${url}/create`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      },
      data
    };
    axios(options)
      .then(res => {
        commit(actionsTypes.ADD_CTA_SUCCESS, {
          data: res.data.cta
        });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(actionsTypes.ADD_CTA_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(actionsTypes.ADD_CTA_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(actionsTypes.ADD_CTA_FAILED, { error });
      });
  },
  fetchAllCTA({ commit }) {
    const ls = storage.get('manager');
    commit(actionsTypes.FETCH_CTAS_REQUEST);
    // socket.emit('fetch actions', { manager_email: ls.profile.email });
    // socket.on('actions', function(data) {
    //   commit(actionsTypes.FETCH_CTAS_SUCCESS, {
    //     data: { actions: data }
    //   });
    // });
    // socket.on('fetch action error', err => {
    //   return commit(actionsTypes.FETCH_CTAS_FAILED, {
    //     error: err.message
    //   });
    // });

    const options = {
      url: `${url}/all?resultSize=1000&page=1`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      }
    };
    axios(options)
      .then(res => {
        commit(actionsTypes.FETCH_CTAS_SUCCESS, {
          data: { actions: res.data.ctas.docs }
        });
      })
      .catch(err => {
      });
  },
  updateCTA({ commit }, cta) {
    const ls = storage.get('manager');
    commit(actionsTypes.UPDATE_CTA_REQUEST);
    const options = {
      url: `${url}/update/${cta._id}`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      },
      data: {
        type: cta.type,
        description: cta.description,
        title: cta.title,
        donationType: cta.donationType ? cta.donationType : '',
        archived: cta.archived
      }
    };
    
    axios(options)
      .then(res => {
        commit(actionsTypes.UPDATE_CTA_SUCCESS, {
          updated: { action: res.data.cta }
        });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(actionsTypes.UPDATE_CTA_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(actionsTypes.UPDATE_CTA_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(actionsTypes.UPDATE_CTA_FAILED, { error });
      });
  },
  deleteCTA({ commit }, action) {
    const ls = storage.get('manager');
    commit(actionsTypes.DELETE_CTA_REQUEST);
    const options = {
      url: `${url}/delete/${action._id}`,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ls.token}`
      }
    };
    axios(options)
      .then(res => {
        commit(actionsTypes.DELETE_CTA_SUCCESS, {
          deleted: { action: res.data.cta }
        });
        // socket.emit('fetch actions', { manager_email: ls.profile.email });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(actionsTypes.DELETE_CTA_FAILED, {
            error: 'Network error'
          });
        }

        if (err && err.response && err.response.status === 404) {
          return commit(actionsTypes.DELETE_CTA_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(actionsTypes.DELETE_CTA_FAILED, { error });
      });
  }
};
